(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/bet-amount-picker/assets/javascripts/bet-amount-picker.js') >= 0) return;  svs.modules.push('/components/sport/bet-amount-picker/assets/javascripts/bet-amount-picker.js'); 
'use strict';

var svs = svs || {};

(function(svs) {
  svs.sport = svs.sport || {};

  svs.sport.BetAmountPicker = function(element, options) {
    var self = this;
    var defaults = {
      betAmounts: [0],
      currentBetAmount: 0,
      isValid: true,
      hideZero: false, 
      showCustomBetAmount: true,
      minAmount: 1,
      maxAmount: 500,
      betAmountPickerId: 1,
      buttonCSSClass: 'btn-default',
      buttonSize: '100',
      errorStyleInverted: true,
      informationText: '',
      onBetAmountChanged: function() {},
      onValidationChanged: function() {
        return false;
      },
      checkZeroValue: function(val) {
        if (this.hideZero && val === 0) {
          val = '';
        }

        return val;
      }
    };

    this.options = {};
    $.extend(this.options, defaults, options);
    this.latestValue = {};

    this.options.betAmountPickerName =
      'bet-amount-picker-radio[' + this.options.betAmountPickerId + ']';

    if (element instanceof jQuery) {
      this.$el = element;
    } else {
      this.$el = $(element);
    }

    this.$el.addClass('bet-amounts');
    this.$el.html(
      svs.sport.bet_amount_picker.templates.bet_amount_picker(this.options)
    );

    if ($('.selected', this.$el).length === 0) {
      var val = this.options.currentBetAmount;
      $('.js-bet-amounts-custom', this.$el).val(
        this.options.checkZeroValue(val)
      );
    }

    $('.js-bet-amounts-custom', this.$el).toggleClass(
      'invalid',
      !this.options.isValid
    );

    this.$el.on('change', '.js-bet-amount', function() {
      self.betAmountClick(this);
    });

    this.$el.on('change', '.js-bet-amounts-custom', function() {
      self.betAmountInputChanged(this);
    });

    this.$el.on('blur', '.js-bet-amounts-custom', function() {
      if (svs.core.detect.formfactor.mobile() && svs.core.detect.os.iOS()) {
        $('body').animate(
          {
            scrollTop: self.scrollTop
          },
          1
        );
      }

      self.betAmountInputChanged(this);
    });

    this.$el.on('keyup', '.js-bet-amounts-custom', function() {
      self.inputKeyDown(this);
    });

    this.$el.on('focus', '.js-bet-amounts-custom', function() {
      self.scrollTop = $(window).scrollTop();
      self.focus(this);
    });

    this.$el.on('focusout', '.js-bet-amounts-custom', function() {
      self.focusout(this);
    });

    return {
      $el: self.$el,
      onBetAmountChanged: self.options.onBetAmountChanged,
      currentBetAmount: self.options.currentBetAmount,
      onValidationChanged: self.options.onValidationChanged,
      isValid: self.options.isValid
    };
  };

  svs.sport.BetAmountPicker.prototype.validate = function($item, trigger) {
    var valid = false,
      value;
    if ($.isNumeric($item.val())) {
      value = parseInt($item.val(), 10);
      valid = !(
        value > this.options.maxAmount || value < this.options.minAmount
      );
      if (String(value).length > String(this.options.maxAmount).length) {
        value = $item.val().substring(0, $item.val().length - 1);
        $item.val(value);
        valid = value < this.options.maxAmount;
        value = parseInt(value, 10);
      }
    } else {
      valid = false;
    }

    if (this.options.hideZero) {
      valid = !isNaN(value);
    }

    if (this.options.isValid !== valid && trigger && !isNaN(value)) {
      this.options.isValid = valid;
      this.options.onValidationChanged(valid, value);
    }
    return valid;
  };

  svs.sport.BetAmountPicker.prototype.betAmountClick = function(element) {
    var $item = $(element),
      self = this,
      val = parseInt($item.val(), 10);
    window.requestIdleCallback(function() {
      if (!isNaN(val)) {
        if (!self.isValid) {
          self.isValid = true;
          self.options.onValidationChanged(true, val);
        } else {
          self.options.onBetAmountChanged(val);
        }
      }
    });
  };

  svs.sport.BetAmountPicker.prototype.betAmountInputChanged = function(
    element
  ) {
    var $item = $(element),
      valid = this.validate($item, true),
      val = parseInt($item.val(), 10);

    $item.toggleClass('invalid', !valid);

    if (valid && !isNaN(val)) {
      this.options.onBetAmountChanged(val);
    }
  };

  svs.sport.BetAmountPicker.prototype.inputKeyDown = function(element) {
    var $item = $(element),
      valid,
      val = $item.val();

    val = val.replace(/[^\d]/g, '');

    $item.val(val);

    val = this.options.checkZeroValue(val);

    if (val !== '') {
      this.latestValue = val;
    }

    valid = this.validate($item, false);
    $item.toggleClass('invalid', !valid);
  };

  svs.sport.BetAmountPicker.prototype.focus = function(element) {
    if (this.options.onFocus) {
      this.options.onFocus();
    }
    var val = $(element).val();

    this.latestValue = this.options.checkZeroValue(val);
    window.requestIdleCallback(function() {
      $(element).val('');
    });
  };

  svs.sport.BetAmountPicker.prototype.focusout = function(element) {
    $(element).val(this.latestValue);
    var $item = $(element),
      valid = this.validate($item, true);
    $item.toggleClass('invalid', !valid);
  };
})(svs);

 })(window);